import { render } from "./ProviderObject.vue?vue&type=template&id=960c44e6&scoped=true"
import script from "./ProviderObject.vue?vue&type=script&lang=js"
export * from "./ProviderObject.vue?vue&type=script&lang=js"

import "./ProviderObject.vue?vue&type=style&index=0&id=960c44e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-960c44e6"]])

export default __exports__